import { Link } from 'react-router-dom';
import { statsData } from '@/mocks/articles';

export default function CTASection() {
  return (
    <section className="px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="text-center max-w-2xl mx-auto mb-8 md:mb-10">
        <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
          有猛料？立即爆料
        </h2>
        <p className="mt-3 text-sm md:text-base text-foreground-500 leading-relaxed">
          如果你有第一手爆料信息，欢迎联系我们。你的每一次爆料，都是推动真相的力量。
        </p>
        <Link
          to="/category/wangbaomen"
          className="mt-5 inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-bold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-send-plane-line"></i>
          <span>我要爆料</span>
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
        {statsData.map((stat) => (
          <div
            key={stat.label}
            className="text-center p-5 md:p-6 rounded-lg bg-background-100"
          >
            <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-50 text-primary-500">
              <i className={`${stat.icon} text-xl`}></i>
            </div>
            <p className="mt-3 text-xl md:text-2xl font-bold text-foreground-950">{stat.value}</p>
            <p className="mt-1 text-xs text-foreground-500">{stat.label}</p>
          </div>
        ))}
      </div>

      <div className="mt-8 w-full h-32 md:h-40 rounded-lg overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20modern%20horizontal%20banner%20illustration%2C%20warm%20coral%20and%20amber%20gradient%2C%20stylized%20floating%20speech%20bubbles%20and%20notification%20icons%2C%20dynamic%20news%20and%20social%20media%20theme%2C%20clean%20minimalist%20design%20with%20geometric%20elements%2C%20soft%20warm%20lighting%2C%20editorial%20aesthetic%2C%20no%20text%2C%20pure%20abstract%20visual&width=1600&height=400&seq=cta-banner-51chigua&orientation=landscape"
          alt="51吃瓜黑料网 - 爆料投稿"
          className="w-full h-full object-cover object-top"
        />
      </div>
    </section>
  );
}